<template>
	<div class="card-container" :class="{'no-header': noHeader, alpha, inset}">
		<div class="card-header">
			<slot name="header">
				<h3>{{ title }}</h3>
				<div>
					<AppButton v-if="buttonText" :text="buttonText" :outline="buttonOutline" :loading="buttonLoading" @click="this.$emit('button-click')"></AppButton>
				</div>
			</slot>
		</div>
		<div class="card-body">
			<slot name="body"></slot>
		</div>
	</div>
</template>

<script>
import AppButton from "@/shared/components/AppButton.vue";
import {useLanguageStore} from "@/shared/stores";

export default {
	setup() {
		const languageStore = useLanguageStore();
		return {getString: languageStore.getString}
	},
	emits: ["button-click"],
	name: "AppCard",
	components: {AppButton},
	props: {
		title: {type: String, required: false, default: null},
		buttonText: {type: String, required: false, default: null},
		buttonOutline: {type: Boolean, required: false, default: false},
		buttonLoading: {type: Boolean, required: false, default: false},
		noHeader: {type: Boolean, required: false, default: false},
		alpha: {type: Boolean, required: false, default: false},
		inset: {type: Boolean, required: false, default: false},
	},
}
</script>

<style lang="scss" scoped>

.card-container {
	padding: 0;
	border-radius: 13px;
	background-color: var(--color-bg);
	box-shadow: 0 3px 5px var(--color-box-shadow-3);
	width: 100%;

	&.alpha { background-color: $alpha_1; }
	&.inset { box-shadow: $box_shadow_inset; }

	.card-header {
		@include row;
		@include justifyFlex(between);
		@include alignFlex(center);
		background-color: var(--color-bg-primary-2);
		position: relative;
		width: 100%;
		padding: 10px 12px;
		border-radius: 13px 13px 0 0;
		flex-wrap: unset;
		min-height: 55px;

		h3 {
			font-size: 18px;
			font-weight: 600;
			color: $txt_0;
			@include truncateString(1);
			padding-right: 5px;
		}

		@media (max-width: 768px) {
			padding: 10px 8px;

			h3 {
				font-size: 16px;
			}
		}
	}

	&.no-header .card-header {
		display: none;
	}

	.card-body {
		padding: 12px;
		position: relative;

		@media (max-width: 768px) {
			padding: 8px;
		}

	}
}

</style>